import { createReducer } from 'store/helpers';
import {
  SET_ERROR,
  CLEAR_ERROR,
  REQUEST_STARTED,
  REQUEST_COMPLETED,
  SET_API_KEYS,
  SET_CREATED_KEY,
  REMOVE_CREATED_KEY,
} from 'store/actions/apiKeys';
import { addIdPrefix } from 'services/common';

const initialState = {
  apiKeys: [],
  isFetching: false,
  error: '',
  createdApiKey: '',
};

const setError = (state, { error }) =>
  state.merge({ error: addIdPrefix(error) });

const clearError = state => state.merge({ error: '' });

const requestStarted = state => state.merge({ isFetching: true });

const requestCompleted = state => state.merge({ isFetching: false });

const setApiKeys = (state, { keys }) => state.merge({ apiKeys: keys });

const setCreatedKey = (state, { apiKey }) =>
  state.merge({ createdApiKey: apiKey });

const removeCreatedKey = state => state.merge({ createdApiKey: '' });

const handlers = {
  [SET_ERROR]: setError,
  [CLEAR_ERROR]: clearError,
  [REQUEST_STARTED]: requestStarted,
  [REQUEST_COMPLETED]: requestCompleted,
  [SET_API_KEYS]: setApiKeys,
  [SET_CREATED_KEY]: setCreatedKey,
  [REMOVE_CREATED_KEY]: removeCreatedKey,
};

export default createReducer(initialState, handlers);
